const hasValue = (value) => value !== "" && value !== null && value !== undefined;

const getParsedAmount = (value) => {
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const HUB_EMPTY_BILL = {
  image: null,
  preview: null,
  type: "",
  date: "",
  baseAmount: "",
  gstAmount: "",
  totalAmount: "",
  bill_type: "vendor",
};

export const EMPLOYEE_EMPTY_BILL = {
  image: null,
  preview: null,
  type: "",
  description: "",
  location: "",
  baseAmount: "",
  gstAmount: "",
  totalAmount: "",
  bills_attached: false,
  date: "",
  bill_type: "vendor",
};

export const clearIndexedFieldErrors = (errors, index, fieldNames) => {
  const nextErrors = { ...errors };

  fieldNames.forEach((fieldName) => {
    delete nextErrors[`${fieldName}-${index}`];
  });

  return nextErrors;
};

export const validateHubBills = (bills) => {
  const errors = {};

  bills.forEach((bill, index) => {
    const baseAmount = getParsedAmount(bill.baseAmount);
    const gstAmount = getParsedAmount(bill.gstAmount);
    const totalAmount = getParsedAmount(bill.totalAmount);

    if (!bill.image) errors[`image-${index}`] = "Image is required";
    if (!bill.type) errors[`type-${index}`] = "Bill type is required";

    if (!hasValue(bill.baseAmount)) errors[`baseAmount-${index}`] = "Base Amount is required";
    else if (baseAmount < 0) errors[`baseAmount-${index}`] = "Please enter a positive number.";

    if (!hasValue(bill.gstAmount)) errors[`gstAmount-${index}`] = "GST Amount is required";
    else if (gstAmount < 0) errors[`gstAmount-${index}`] = "Please enter a positive number.";

    if (!hasValue(bill.totalAmount)) errors[`totalAmount-${index}`] = "Total Amount is required";
    else if (totalAmount < 0) errors[`totalAmount-${index}`] = "Please enter a positive number.";
    else if (totalAmount === 0) errors[`totalAmount-${index}`] = "Total Amount must be greater than 0.";
  });

  return errors;
};

export const validateEmployeeBills = (bills) => {
  const errors = {};

  bills.forEach((bill, index) => {
    const baseAmount = getParsedAmount(bill.baseAmount);
    const gstAmount = getParsedAmount(bill.gstAmount);
    const totalAmount = getParsedAmount(bill.totalAmount);

    if (!bill.type) errors[`type-${index}`] = "Bill type is required";

    if (!hasValue(bill.baseAmount)) errors[`baseAmount-${index}`] = "Base Amount is required";
    else if (baseAmount < 0) errors[`baseAmount-${index}`] = "Please enter a positive number.";

    if (!hasValue(bill.gstAmount)) errors[`gstAmount-${index}`] = "GST Amount is required";
    else if (gstAmount < 0) errors[`gstAmount-${index}`] = "Please enter a positive number.";

    if (!hasValue(bill.totalAmount)) errors[`totalAmount-${index}`] = "Total Amount is required";
    else if (totalAmount < 0) errors[`totalAmount-${index}`] = "Please enter a positive number.";
    else if (totalAmount === 0) errors[`totalAmount-${index}`] = "Total Amount must be greater than 0.";

    if (!bill.date) errors[`date-${index}`] = "Date is required";
    if (!bill.description?.trim()) errors[`description-${index}`] = "Description is required";
    if (!bill.image) errors[`image-${index}`] = "Image is required";
  });

  return errors;
};
